"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { cn } from "@/utils/cn";
import { ArrowLeft, ArrowRight, Building2, Heart, Home as HomeIcon, Loader2, TrendingUp, UserCheck, Users } from "lucide-react";
import { UserGroup } from "./types";
interface RelationshipDialogContentProps {
  step: "initial" | "group-selection";
  pendingRelationship: "buyer" | "seller" | null;
  groupsByRelationship: {
    buyer: UserGroup[];
    seller: UserGroup[];
  };
  isLoading: boolean;
  selectedGroupId: string | null;
  selectedRelationship: "buyer" | "seller" | null;
  effectiveMode: "selection" | "guard";
  mode?: "selection" | "guard";
  requiredRelationship?: "buyer" | "seller";
  currentRelationship?: "buyer" | "seller";
  featureName?: string;
  description?: string;
  onClose: () => void;
  onBack: () => void;
  onGroupSelect: (groupId: string) => void;
  onRelationshipSwitch: (relationship: "buyer" | "seller") => void;
}
export function RelationshipDialogContent(t0) {
  const $ = _c(143);
  const {
    step,
    pendingRelationship,
    groupsByRelationship,
    isLoading,
    selectedGroupId,
    effectiveMode,
    requiredRelationship,
    currentRelationship,
    featureName,
    description,
    onClose,
    onBack,
    onGroupSelect,
    onRelationshipSwitch
  } = t0;
  if (step === "group-selection" && pendingRelationship) {
    let t1;
    if ($[0] !== groupsByRelationship || $[1] !== pendingRelationship) {
      t1 = groupsByRelationship[pendingRelationship] || [];
      $[0] = groupsByRelationship;
      $[1] = pendingRelationship;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    const groups = t1;
    const RelationshipIcon = pendingRelationship === "buyer" ? Heart : Building2;
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[3] !== RelationshipIcon || $[4] !== isLoading || $[5] !== onBack || $[6] !== pendingRelationship) {
      const relationshipStyles = pendingRelationship === "buyer" ? {
        bg: "bg-blue-100",
        text: "text-blue-600"
      } : {
        bg: "bg-green-100",
        text: "text-green-600"
      };
      t6 = "space-y-4";
      let t8;
      if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = <ArrowLeft className="w-5 h-5" />;
        $[14] = t8;
      } else {
        t8 = $[14];
      }
      let t9;
      if ($[15] !== isLoading || $[16] !== onBack) {
        t9 = <button onClick={onBack} disabled={isLoading} className="p-1 rounded-full hover:bg-gray-100 text-gray-500" aria-label="Back">{t8}</button>;
        $[15] = isLoading;
        $[16] = onBack;
        $[17] = t9;
      } else {
        t9 = $[17];
      }
      let t10;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <span className="font-semibold text-gray-900">Select Group</span>;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      if ($[19] !== t9) {
        t7 = <div className="flex items-center gap-2 mb-4">{t9}{t10}</div>;
        $[19] = t9;
        $[20] = t7;
      } else {
        t7 = $[20];
      }
      t5 = "text-center mb-6";
      t4 = "flex items-center justify-center gap-3 mb-2";
      t3 = cn("w-10 h-10 rounded-lg flex items-center justify-center", relationshipStyles.bg);
      T0 = RelationshipIcon;
      t2 = cn("w-5 h-5", relationshipStyles.text);
      $[3] = RelationshipIcon;
      $[4] = isLoading;
      $[5] = onBack;
      $[6] = pendingRelationship;
      $[7] = T0;
      $[8] = t2;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
      $[12] = t6;
      $[13] = t7;
    } else {
      T0 = $[7];
      t2 = $[8];
      t3 = $[9];
      t4 = $[10];
      t5 = $[11];
      t6 = $[12];
      t7 = $[13];
    }
    let t8;
    if ($[21] !== T0 || $[22] !== t2) {
      t8 = <T0 className={t2} />;
      $[21] = T0;
      $[22] = t2;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    let t9;
    if ($[24] !== t3 || $[25] !== t8) {
      t9 = <div className={t3}>{t8}</div>;
      $[24] = t3;
      $[25] = t8;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] !== pendingRelationship) {
      t10 = <h2 className="text-xl font-bold text-primary-900 capitalize">{pendingRelationship} Groups</h2>;
      $[27] = pendingRelationship;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    let t11;
    if ($[29] !== t10 || $[30] !== t4 || $[31] !== t9) {
      t11 = <div className={t4}>{t9}{t10}</div>;
      $[29] = t10;
      $[30] = t4;
      $[31] = t9;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    let t12;
    if ($[33] !== pendingRelationship) {
      t12 = <p className="text-primary-700 text-sm max-w-sm mx-auto">Select which group you want to use for {pendingRelationship} mode.</p>;
      $[33] = pendingRelationship;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t13;
    if ($[35] !== t11 || $[36] !== t12 || $[37] !== t5) {
      t13 = <div className={t5}>{t11}{t12}</div>;
      $[35] = t11;
      $[36] = t12;
      $[37] = t5;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    let t14;
    if ($[39] !== groups || $[40] !== isLoading || $[41] !== onGroupSelect || $[42] !== selectedGroupId) {
      let t15;
      if ($[44] !== isLoading || $[45] !== onGroupSelect || $[46] !== selectedGroupId) {
        t15 = group => {
          const isSelected = selectedGroupId === group.id;
          const members = group.members || [];
          return <div key={group.id} className={cn("relative p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 text-left", isSelected ? "border-primary-500 bg-primary-50 shadow-md" : "border-gray-200 hover:border-primary-300 hover:bg-gray-50", isLoading && "opacity-50 pointer-events-none")} onClick={() => !isLoading && onGroupSelect(group.id)}><div className="flex items-start gap-3"><div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center"><Users className="w-4 h-4 text-gray-600" /></div><div className="flex-1 min-w-0"><h3 className={cn("font-medium text-sm mb-1", isSelected ? "text-primary-900" : "text-gray-900")}>{group.name}</h3><p className="text-xs text-gray-500 capitalize">{group.type}</p>{members.length > 0 && <div className="mt-2 text-xs text-gray-500">{members.length} member{members.length !== 1 ? "s" : ""}</div>}</div></div>{isLoading && selectedGroupId === group.id && <div className="absolute inset-0 bg-white/80 rounded-lg flex items-center justify-center"><Loader2 className="w-5 h-5 animate-spin text-primary-600" /></div>}</div>;
        };
        $[44] = isLoading;
        $[45] = onGroupSelect;
        $[46] = selectedGroupId;
        $[47] = t15;
      } else {
        t15 = $[47];
      }
      t14 = groups.map(t15);
      $[39] = groups;
      $[40] = isLoading;
      $[41] = onGroupSelect;
      $[42] = selectedGroupId;
      $[43] = t14;
    } else {
      t14 = $[43];
    }
    let t15;
    if ($[48] !== t14) {
      t15 = <div className="space-y-3 max-h-[40vh] overflow-y-auto mb-6">{t14}</div>;
      $[48] = t14;
      $[49] = t15;
    } else {
      t15 = $[49];
    }
    let t16;
    if ($[50] !== t13 || $[51] !== t15 || $[52] !== t6 || $[53] !== t7) {
      t16 = <div className={t6}>{t7}{t13}{t15}</div>;
      $[50] = t13;
      $[51] = t15;
      $[52] = t6;
      $[53] = t7;
      $[54] = t16;
    } else {
      t16 = $[54];
    }
    return t16;
  }
  if (effectiveMode === "selection") {
    let t1;
    let t2;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="bg-gradient-to-br from-primary-50 to-primary-100 px-6 py-8 text-center -mx-6 -mt-6 mb-6"><h2 className="text-2xl font-bold text-primary-900 mb-2">Choose Your Relationship</h2><p className="text-primary-700 text-base">Tell us how you would like to use Settlin. You can change this anytime.</p></div>;
      t2 = cn("relative p-4 rounded-xl border-2 cursor-pointer transition-all duration-200", "border-gray-200 hover:border-primary-300 hover:bg-gray-50");
      $[55] = t1;
      $[56] = t2;
    } else {
      t1 = $[55];
      t2 = $[56];
    }
    let t3;
    if ($[57] !== isLoading || $[58] !== onRelationshipSwitch) {
      t3 = () => !isLoading && onRelationshipSwitch("buyer");
      $[57] = isLoading;
      $[58] = onRelationshipSwitch;
      $[59] = t3;
    } else {
      t3 = $[59];
    }
    let t4;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center"><HomeIcon className="w-6 h-6 text-blue-600" /></div>;
      $[60] = t4;
    } else {
      t4 = $[60];
    }
    let t5;
    let t6;
    if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <h3 className="font-semibold text-gray-900 mb-1">I want to buy</h3>;
      t6 = <p className="text-sm text-gray-600 mb-2">Find and purchase properties. Browse listings, schedule visits, and get assistance with buying.</p>;
      $[61] = t5;
      $[62] = t6;
    } else {
      t5 = $[61];
      t6 = $[62];
    }
    let t7;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="flex items-start gap-4">{t4}<div className="flex-1">{t5}{t6}<div className="flex items-center text-sm text-primary-600 font-medium"><span>Get started as a buyer</span><ArrowRight className="w-4 h-4 ml-1" /></div></div></div>;
      $[63] = t7;
    } else {
      t7 = $[63];
    }
    let t8;
    if ($[64] !== t3) {
      t8 = <div className={t2} onClick={t3}>{t7}</div>;
      $[64] = t3;
      $[65] = t8;
    } else {
      t8 = $[65];
    }
    let t9;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = cn("relative p-4 rounded-xl border-2 cursor-pointer transition-all duration-200", "border-gray-200 hover:border-primary-300 hover:bg-gray-50");
      $[66] = t9;
    } else {
      t9 = $[66];
    }
    let t10;
    if ($[67] !== isLoading || $[68] !== onRelationshipSwitch) {
      t10 = () => !isLoading && onRelationshipSwitch("seller");
      $[67] = isLoading;
      $[68] = onRelationshipSwitch;
      $[69] = t10;
    } else {
      t10 = $[69];
    }
    let t11;
    if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center"><TrendingUp className="w-6 h-6 text-green-600" /></div>;
      $[70] = t11;
    } else {
      t11 = $[70];
    }
    let t12;
    let t13;
    if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <h3 className="font-semibold text-gray-900 mb-1">I want to sell</h3>;
      t13 = <p className="text-sm text-gray-600 mb-2">List and sell properties. Post listings, manage inquiries, and get help with selling.</p>;
      $[71] = t12;
      $[72] = t13;
    } else {
      t12 = $[71];
      t13 = $[72];
    }
    let t14;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="flex items-start gap-4">{t11}<div className="flex-1">{t12}{t13}<div className="flex items-center text-sm text-primary-600 font-medium"><span>Get started as a seller</span><ArrowRight className="w-4 h-4 ml-1" /></div></div></div>;
      $[73] = t14;
    } else {
      t14 = $[73];
    }
    let t15;
    if ($[74] !== t10) {
      t15 = <div className={t9} onClick={t10}>{t14}</div>;
      $[74] = t10;
      $[75] = t15;
    } else {
      t15 = $[75];
    }
    let t16;
    if ($[76] !== isLoading || $[77] !== onClose) {
      t16 = <div className="pt-2"><Button variant="outline" onPress={onClose} isDisabled={isLoading} className="w-full">Skip for now</Button></div>;
      $[76] = isLoading;
      $[77] = onClose;
      $[78] = t16;
    } else {
      t16 = $[78];
    }
    let t17;
    if ($[79] !== isLoading) {
      t17 = isLoading && <div className="absolute inset-0 bg-white/50 flex items-center justify-center z-10"><Loader2 className="w-8 h-8 animate-spin text-primary-600" /></div>;
      $[79] = isLoading;
      $[80] = t17;
    } else {
      t17 = $[80];
    }
    let t18;
    if ($[81] !== t15 || $[82] !== t16 || $[83] !== t17 || $[84] !== t8) {
      t18 = <div className="space-y-4">{t1}{t8}{t15}{t16}{t17}</div>;
      $[81] = t15;
      $[82] = t16;
      $[83] = t17;
      $[84] = t8;
      $[85] = t18;
    } else {
      t18 = $[85];
    }
    return t18;
  } else {
    let t1;
    if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        label: "Buyer",
        description: "Find and purchase properties",
        icon: <UserCheck className="w-8 h-8 text-white" />,
        color: "from-blue-500 to-blue-600"
      };
      $[86] = t1;
    } else {
      t1 = $[86];
    }
    let t2;
    if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        buyer: t1,
        seller: {
          label: "Seller",
          description: "List and sell properties",
          icon: <Users className="w-8 h-8 text-white" />,
          color: "from-green-500 to-green-600"
        }
      };
      $[87] = t2;
    } else {
      t2 = $[87];
    }
    const relationshipConfig = t2;
    const required = relationshipConfig[requiredRelationship || "buyer"];
    const current = relationshipConfig[currentRelationship || "buyer"];
    const canSwitch = groupsByRelationship[requiredRelationship]?.length > 0;
    const t3 = `w-16 h-16 mx-auto bg-gradient-to-br ${required.color} rounded-2xl flex items-center justify-center`;
    let t4;
    if ($[88] !== required.icon || $[89] !== t3) {
      t4 = <div className={t3}>{required.icon}</div>;
      $[88] = required.icon;
      $[89] = t3;
      $[90] = t4;
    } else {
      t4 = $[90];
    }
    let t5;
    if ($[91] !== featureName || $[92] !== required.label) {
      t5 = <h2 className="text-xl font-bold text-gray-900 mb-2">{featureName} for {required.label}s</h2>;
      $[91] = featureName;
      $[92] = required.label;
      $[93] = t5;
    } else {
      t5 = $[93];
    }
    let t6;
    if ($[94] !== description) {
      t6 = description && <p className="text-sm text-gray-600 leading-relaxed max-w-sm mx-auto">{description}</p>;
      $[94] = description;
      $[95] = t6;
    } else {
      t6 = $[95];
    }
    let t7;
    if ($[96] !== t5 || $[97] !== t6) {
      t7 = <div>{t5}{t6}</div>;
      $[96] = t5;
      $[97] = t6;
      $[98] = t7;
    } else {
      t7 = $[98];
    }
    let t8;
    if ($[99] !== t4 || $[100] !== t7) {
      t8 = <div className="text-center space-y-4">{t4}{t7}</div>;
      $[99] = t4;
      $[100] = t7;
      $[101] = t8;
    } else {
      t8 = $[101];
    }
    const t9 = `w-10 h-10 bg-gradient-to-br ${current.color} rounded-lg flex items-center justify-center`;
    let t10;
    if ($[102] !== current.icon || $[103] !== t9) {
      t10 = <div className={t9}>{current.icon}</div>;
      $[102] = current.icon;
      $[103] = t9;
      $[104] = t10;
    } else {
      t10 = $[104];
    }
    let t11;
    if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <p className="text-sm font-medium text-gray-900">Currently signed in as</p>;
      $[105] = t11;
    } else {
      t11 = $[105];
    }
    let t12;
    if ($[106] !== current.label) {
      t12 = <div>{t11}<p className="text-lg font-semibold text-gray-800">{current.label}</p></div>;
      $[106] = current.label;
      $[107] = t12;
    } else {
      t12 = $[107];
    }
    let t13;
    if ($[108] !== t10 || $[109] !== t12) {
      t13 = <div className="flex items-center gap-3 mb-3">{t10}{t12}</div>;
      $[108] = t10;
      $[109] = t12;
      $[110] = t13;
    } else {
      t13 = $[110];
    }
    let t14;
    if ($[111] !== current.description) {
      t14 = <p className="text-xs text-gray-600">{current.description}</p>;
      $[111] = current.description;
      $[112] = t14;
    } else {
      t14 = $[112];
    }
    let t15;
    if ($[113] !== t13 || $[114] !== t14) {
      t15 = <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">{t13}{t14}</div>;
      $[113] = t13;
      $[114] = t14;
      $[115] = t15;
    } else {
      t15 = $[115];
    }
    const t16 = `w-10 h-10 bg-gradient-to-br ${required.color} rounded-lg flex items-center justify-center`;
    let t17;
    if ($[116] !== required.icon || $[117] !== t16) {
      t17 = <div className={t16}>{required.icon}</div>;
      $[116] = required.icon;
      $[117] = t16;
      $[118] = t17;
    } else {
      t17 = $[118];
    }
    let t18;
    if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <p className="text-sm font-medium text-gray-700">This feature requires</p>;
      $[119] = t18;
    } else {
      t18 = $[119];
    }
    let t19;
    if ($[120] !== required.label) {
      t19 = <div>{t18}<p className="text-lg font-semibold text-gray-900">{required.label} Access</p></div>;
      $[120] = required.label;
      $[121] = t19;
    } else {
      t19 = $[121];
    }
    let t20;
    if ($[122] !== t17 || $[123] !== t19) {
      t20 = <div className="flex items-center gap-3 mb-4">{t17}{t19}</div>;
      $[122] = t17;
      $[123] = t19;
      $[124] = t20;
    } else {
      t20 = $[124];
    }
    let t21;
    if ($[125] !== canSwitch || $[126] !== required.label) {
      t21 = canSwitch ? <div className="bg-white/50 rounded-lg p-3 border border-primary-200 mb-4"><p className="text-xs text-gray-600 mb-2"><strong>Good news!</strong> You can switch to {required.label} mode right now.</p></div> : <div className="bg-white/50 rounded-lg p-3 border border-primary-200 mb-4"><p className="text-xs text-gray-600 mb-2"><strong>How to get access:</strong></p><ol className="text-xs text-gray-600 space-y-1"><li>1. Contact support to set up your {required.label} account</li><li>2. Once approved, you'll be able to switch relationships</li><li>3. Return to access this feature</li></ol></div>;
      $[125] = canSwitch;
      $[126] = required.label;
      $[127] = t21;
    } else {
      t21 = $[127];
    }
    let t22;
    if ($[128] !== t20 || $[129] !== t21) {
      t22 = <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-6">{t20}{t21}</div>;
      $[128] = t20;
      $[129] = t21;
      $[130] = t22;
    } else {
      t22 = $[130];
    }
    let t23;
    if ($[131] !== canSwitch || $[132] !== isLoading || $[133] !== onClose || $[134] !== onRelationshipSwitch || $[135] !== required.label || $[136] !== requiredRelationship) {
      t23 = <div className="pt-2 space-y-3">{canSwitch ? <><button type="button" onClick={() => onRelationshipSwitch(requiredRelationship)} disabled={isLoading} className={cn("w-full bg-primary text-white rounded-xl py-3 px-4 font-medium transition-colors", "hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed", "flex items-center justify-center gap-2")}>{isLoading ? <><Loader2 className="w-4 h-4 animate-spin" />Switching...</> : <>Switch to {required.label} Mode</>}</button><button onClick={onClose} disabled={isLoading} className="w-full bg-gray-100 text-gray-700 rounded-xl py-3 px-4 font-medium hover:bg-gray-200 transition-colors disabled:opacity-50">Maybe Later</button></> : <button onClick={onClose} className="w-full bg-primary text-white rounded-xl py-3 px-4 font-medium hover:bg-primary/90 transition-colors">Got it, I'll contact support</button>}</div>;
      $[131] = canSwitch;
      $[132] = isLoading;
      $[133] = onClose;
      $[134] = onRelationshipSwitch;
      $[135] = required.label;
      $[136] = requiredRelationship;
      $[137] = t23;
    } else {
      t23 = $[137];
    }
    let t24;
    if ($[138] !== t15 || $[139] !== t22 || $[140] !== t23 || $[141] !== t8) {
      t24 = <div className="space-y-6">{t8}{t15}{t22}{t23}</div>;
      $[138] = t15;
      $[139] = t22;
      $[140] = t23;
      $[141] = t8;
      $[142] = t24;
    } else {
      t24 = $[142];
    }
    return t24;
  }
}